<header>
  <h3 class="title">Filters</h3>

  <app-button
    class="icon"
    color="neutral"
    (click)="detachBar()">
    <mat-icon>close</mat-icon>
  </app-button>
</header>

<div class="search">
  <app-search-field [(model)]="query"></app-search-field>
</div>

<div class="content">
  @for (field of viewFields(); track field) {
    <app-filter-row [row]="field" />
  }
</div>
